import decode from 'jwt-decode';
import sign from 'jwt-encode';
import getHash from './getHash';

export const getSignatureHeader = async (jwtSecret: string, urlParams?: Record<string, string>, payload?: any) =>
  sign(
    {
      qry: urlParams && (await getHash(JSON.stringify(urlParams))),
      dta: payload && (await getHash(JSON.stringify(payload)))
    },
    jwtSecret
  );

export const getBasketIdBasedRateLimitingHeader = (payload?: { jwt?: string }) => {
  if (!payload?.jwt) {
    return undefined;
  }
  return decode<{ rBasketId?: string }>(payload.jwt).rBasketId;
};
